interface IMobilePhone {
    regionCode?: number;
    areaCode?: number;
    phoneNumber?: number;
}

class User {
    public id: string;
    public name: string;
    public fullName?: string;
    public document: string;
    public email: string;
    public token: string;
    public picture?: string;
    public birthdate?: string;
    public phone?: any;

    constructor({
        id = '',
        name = '',
        fullName = '',
        cpf = '',
        document = '',
        email = '',
        token = '',
        picture = '',
        birthdate = '',
        phone = ''
    }) {
        this.id = id;
        this.name = name;
        this.fullName = fullName;
        this.document = cpf || document;
        this.email = email;
        this.token = token;
        this.picture = picture;
        this.birthdate = birthdate;
        this.phone = formatPhone(phone);
    }

    // tslint:disable-next-line: member-access
    static formatPhone = formatPhone;
}

function formatPhone(phone): string {
    if (phone && typeof phone === 'object') {
        const { regionCode = '', areaCode = '', phoneNumber = '' } = phone;
        return `${regionCode}${areaCode}${phoneNumber}`;
    }

    return phone || '';
}

export default User;
